"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Notification Service API
 * This is the API specification for the Notification Service.  The Notification Service is used to send any kind of notification to a contact of Arctic Wolf.  In general, the caller will at most decide who to send the notification to, and the Notification Service will determine how to send it based on that contact\'s preferences. **Note that notifications should NEVER contain any PII or sensitive information.**  All notifications should be of a Data Sensitivity Level of 3 or less.  For more information, see [Data Sensitivity Levels](https://arcticwolf.atlassian.net/wiki/spaces/PD/pages/3770155054/Data+Sensitivity+Levels+-+Data+Mapping).
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendToOrgContactsInputToJSON = exports.SendToOrgContactsInputFromJSONTyped = exports.SendToOrgContactsInputFromJSON = exports.instanceOfSendToOrgContactsInput = void 0;
var runtime_1 = require("../runtime");
var Payload_1 = require("./Payload");
var RecipientInput_1 = require("./RecipientInput");
var Sender_1 = require("./Sender");
/**
 * Check if a given object implements the SendToOrgContactsInput interface.
 */
function instanceOfSendToOrgContactsInput(value) {
    var isInstance = true;
    isInstance = isInstance && "notificationType" in value;
    return isInstance;
}
exports.instanceOfSendToOrgContactsInput = instanceOfSendToOrgContactsInput;
function SendToOrgContactsInputFromJSON(json) {
    return SendToOrgContactsInputFromJSONTyped(json, false);
}
exports.SendToOrgContactsInputFromJSON = SendToOrgContactsInputFromJSON;
function SendToOrgContactsInputFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'externalID': !(0, runtime_1.exists)(json, 'externalID') ? undefined : json['externalID'],
        'notificationType': json['notificationType'],
        'payload': !(0, runtime_1.exists)(json, 'payload') ? undefined : (0, Payload_1.PayloadFromJSON)(json['payload']),
        'sender': !(0, runtime_1.exists)(json, 'sender') ? undefined : (0, Sender_1.SenderFromJSON)(json['sender']),
        'recipients': !(0, runtime_1.exists)(json, 'recipients') ? undefined : (0, RecipientInput_1.RecipientInputFromJSON)(json['recipients']),
    };
}
exports.SendToOrgContactsInputFromJSONTyped = SendToOrgContactsInputFromJSONTyped;
function SendToOrgContactsInputToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'externalID': value.externalID,
        'notificationType': value.notificationType,
        'payload': (0, Payload_1.PayloadToJSON)(value.payload),
        'sender': (0, Sender_1.SenderToJSON)(value.sender),
        'recipients': (0, RecipientInput_1.RecipientInputToJSON)(value.recipients),
    };
}
exports.SendToOrgContactsInputToJSON = SendToOrgContactsInputToJSON;
